// Hash navigation also opens the scanner after its lazy-loaded bundle is ready.
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-lens-finder]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (window.__loadEverclearScanner) window.__loadEverclearScanner();
  if (window.location.hash === '#/start-scanner') {
    window.dispatchEvent(new CustomEvent('everclear-scanner:event', { detail: { type: 'openScanner' } }));
  }
});
